import { render, staticRenderFns } from "./cpt-dataV-waterLevel.vue?vue&type=template&id=e4e2e2c2&scoped=true"
import script from "./cpt-dataV-waterLevel.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-waterLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e2e2c2",
  null
  
)

export default component.exports